<template>
  <div
    @paste="paste"
    v-loading="loading"
    element-loading-text="上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="quill_editor-wrapper"
  >
    <div class="quill_div">
      <QuillEditor
        ref="myEditor"
        v-model="invalue"
        :options="options"
        :disabled="readonly"
        class="webkit"
      />
      <div class="drawer-footer">
        <el-button
          type="primary"
          size="mini"
          @click="save()"
          :disabled="!this.invalue || readonly"
        >
          {{ $l('INDEX.btn_send') || '发送' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor as QuillEditor } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'
import EditLoading from '@/mixins/edit-loading'
Quill.register('modules/imageResize', ImageResize)
export default {
  components: { QuillEditor },
  mixins: [EditLoading],
  props: {
    readonly: { type: Boolean, default: false },
    expoMeetingCode: { type: String, default: '' },
    expoInfoCode: { type: String, default: '' },
  },
  data() {
    return {
      invalue: '',
      localTimeZone: '',
      options: {
        modules: {
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
          toolbar: false,
        },
        placeholder:
          this.$l('form_label_pe_information') || '请输入会议记录信息',
      },
      loading: false,
    }
  },

  methods: {
    async save() {
      if (!this.invalue) return
      if (this.loadingOpen()) return

      const fileItems = (await this.uploadBase64Images()) || []
      const messageItems = (await this.getCommentsMessage()) || []
      const data = fileItems.concat(messageItems)

      const commentsTimeZone = await this.loadLocalTimeZone()
      const mustParams = {
        expoMeetingCode: this.expoMeetingCode,
        expoInfoCode: this.expoInfoCode,
        commentsTimeZone,
      }

      if (data && data.length > 0) {
        await this.saveMessage(data, mustParams)
        this.invalue = ''
      }
      this.loadingClose()
    },

    async saveMessage(data, mustParams) {
      const uploadTask = data.map((params) => {
        return this.$api
          .expoMeetingCommentsSaveApi({ ...params, ...mustParams })
          .then(() => {
            this.$emit('getData')
          })
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },

    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },

    async paste(event) {
      const $editor = this.$refs.myEditor
      const quill = $editor.quill
      const clipboardData = event.clipboardData || window.clipboardData

      const text = event.clipboardData.getData('text')
      if (text) {
        quill.focus()
        const range = quill.getSelection()
        quill.insertEmbed(range.index, 'text', text)
      }

      const items = clipboardData.items
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (item.type.indexOf('image') !== -1) {
          const file = item.getAsFile()
          const reader = new FileReader()
          reader.onload = function(event) {
            const range = quill.getSelection()
            const base64Image = event.target.result
            quill.insertEmbed(range.index, 'image', base64Image)
          }
          reader.readAsDataURL(file)
        }
      }
      event.preventDefault()
    },
    getBase64Images() {
      var base64Images = []
      const quill = this.$refs.myEditor.quill
      var delta = quill.getContents()
      delta.ops.forEach(function(op) {
        if (
          op.insert &&
          op.insert.image &&
          op.insert.image.startsWith('data:image')
        ) {
          base64Images.push(op.insert.image)
        }
      })
      return base64Images
    },

    convertBase64ToFile(base64Data) {
      const parts = base64Data.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new File(
        [new Blob([uInt8Array], { type: contentType })],
        'image' + '.' + contentType.split('/')[1],
        { type: contentType }
      )
    },

    convertBase64ToFiles(base64Images) {
      var files = []
      base64Images.forEach((base64Image) => {
        var file = this.convertBase64ToFile(base64Image)
        files.push(file)
      })

      return files
    },

    uploadFiles(files) {
      if (!files?.length) return Promise.resolve([])
      const uploadTask = files.map((file) => {
        return this.$api
          .SYS_UPLOAD(file)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },

    // 上传Base64图片到服务器
    async uploadBase64Images() {
      var base64Images = this.getBase64Images()
      if (base64Images && base64Images.length > 0) {
        var files = this.convertBase64ToFiles(base64Images)
        var fileItems = await this.uploadFiles(files)

        const data = fileItems.map((params) => {
          return {
            ...params,
            commentsType: 'I',
            recordType: 'M',
            displayImageCode: params.fileCode,
            displayImageUrl: params.fileUrl,
          }
        })
        return Promise.all(data)
      }
    },
    getCommentsMessage() {
      var commentsMessages = []
      const quill = this.$refs.myEditor.quill
      var delta = quill.getContents()
      delta.ops.forEach(function(op) {
        if (op.insert && !op.insert.image) {
          commentsMessages.push(op.insert)
        }
      })
      if (commentsMessages && commentsMessages.length > 0) {
        const str = commentsMessages[commentsMessages.length - 1]

        const lastIndex = str.lastIndexOf('\n')
        if (lastIndex !== -1) {
          commentsMessages[commentsMessages.length - 1] = str.substring(
            0,
            lastIndex
          )
        }
      }
      const data = commentsMessages.filter(Boolean).map((params) => {
        if (params) {
          return {
            recordType: 'M',
            commentsType: 'T',
            commentsMessage: params,
          }
        }
      })
      return Promise.all(data)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ql-container {
    min-height: 112px;
    max-height: 112px;
    overflow: auto;
  }
  .ql-editor img {
    max-width: 150px; /* 设置最大宽度 */
    max-height: 70px; /* 设置最大高度 */
  }

  .ql-container.ql-snow {
    border: none;
  }

  .webkit .ql-container {
    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
    &::-webkit-scrollbar-corner {
      background: #179a16;
    }
  }
}

.drawer-footer {
  padding: 5px 10px 10px 10px;
  display: flex;
  justify-content: flex-end;
}

.quill_editor-wrapper {
  line-height: 20px;
  margin-top: 5px;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(16, 16, 16, 1);
  background-color: white;
  padding: 9px 15px 9px 15px;
}

.quill_div {
  background-color: #fafafa;
}
</style>
